// extracted by mini-css-extract-plugin
export default {"f":"_24ebc7bda7","main":"_19342121ca","btn":"e53aa36e20","w":"_105b189bb0","h":"_8342e729ef","lh25":"_1f89d1ff4f","wb":"a484a3a362","b":"d36b0cd3b4","bx":"_35d7b60401"};